import 'core-js/stable'
import 'regenerator-runtime/runtime'
import * as $ from 'jquery'
import 'lazysizes'

import '../../src/util/install_sentry'

import './site_common'

import 'Components/refosumu/home_index/contract_ranking/component'
import 'Components/refosumu/home_index/review_ranking/component'
import 'Components/refosumu/home_index/company_search_form/component'
import 'Components/refosumu/home_index/construction_interview/component'
import 'Components/refosumu/home_index/site_news/component'
import 'Components/refosumu/home_index/main_visual/component'
import 'Components/refosumu/home_index/area_navigation/component'
import 'Components/refosumu/home_index/latest_content/component'
import 'Components/refosumu/home_index/subsidy_section/component'
import 'Components/refosumu/home_index/about_service/component'

import 'Components/refosumu/v2/helpful_column/component'
import 'Components/refosumu/v2/feature/component'
import 'Components/refosumu/v2/partner_companies/component'
import 'Components/refosumu/v2/flow/component'
import 'Components/refosumu/v2/service_renewal/component'
import 'Components/refosumu/v2/faqs/component'
import 'Components/refosumu/v2/floating/component'
import 'Components/refosumu/v2/blue_dotted_line/component'
import 'Components/refosumu/v2/simple_button/component'
import 'Components/refosumu/v2/yellow_dotted_line/component'
import 'Components/refosumu/v2/title_board/component'
import 'Components/refosumu/v2/green_dotted_line/component'
import spToggleNav from '../../src/spToggleNav/spToggleNav'

$(() => {
  spToggleNav()
})
